// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","nav__item":"Footer_nav__item__yvQtA","vertical-line":"Footer_vertical-line__7siA-","nav":"Footer_nav__fiMHa"};